<template>
  <header
    v-if="workPartDetails"
    class="part-details-card-header"
  >
    <div class="part-details-card-header__left">
      <span>Parte de producción {{ workPartNumber }}</span>
      <br>
      <span class="part-details-card-header__order">
        Orden de producción: {{ orderSeriesNumber }}
      </span>
    </div>

    <div class="part-details-card-header__right">
      <div
        v-if="workPartDetails.Nombre_ParteProduccionEstado"
        class="part-details-card-header__status"
      >
        {{ workPartDetails.Nombre_ParteProduccionEstado }}
      </div>

      <div
        v-if="finishedPartDate"
        class="part-details-card-header__date part-details-card-header__date--finish"
      >
        {{ finishedPartDate }}
      </div>

      <div
        v-else-if="workPartDetails.FechaInicio"
        class="part-details-card-header__date part-details-card-header__date--start"
      >
        {{ formatDate(new Date(workPartDetails.FechaInicio)) }}
      </div>

      <div class="part-details-card-header__priority">
        {{ workPartDetails.Prioridad }}
      </div>
    </div>
  </header>
</template>

<script setup>
// @ts-check

import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useRepairPartsStore } from '@/js/stores/repairParts';
import { HiDateTimeSupport } from '@/js/common/HIConversionSupport';

const { workPartDetails } = storeToRefs(useRepairPartsStore());

const workPartNumber = computed(() => (workPartDetails.value ? (`${workPartDetails.value.SerieParte || ''}/${workPartDetails.value.NumeroParte || ''}`) : ''));
const orderSeriesNumber = computed(() => (workPartDetails.value ? (`${workPartDetails.value.SerieOrden || ''}/${workPartDetails.value.NumeroOrden || ''}`) : ''));

const finishedPartDate = computed(() => {
  const details = workPartDetails.value;
  if (!details || !details.FechaFinalizacionOrden) {
    return '';
  }

  const startDate = formatDate(new Date(details.FechaInicio));
  const finishDate = formatDate(new Date(details.FechaFinalizacionOrden));

  return finishDate && finishDate !== startDate
    ? `${startDate} — ${finishDate}`
    : startDate;
});

/**
 * Formats date to the DD/MM/YYYY format.
 * @param {Date} date
 */
function formatDate(date) {
  return HiDateTimeSupport.FormatDateTime(date, 'DD/MM/YYYY');
}
</script>

<style scoped lang="scss">
.part-details-card-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: var(--his-tierra-white);

  &__left {
    color: #253858;
    font-weight: bold;
  }

  &__right {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }

  &__order {
    font-size: smaller;
  }

  &__status {
    color: #fff;
    background-color: var(--his-orange);
    padding: 6px;
    border-radius: 4px;
    font-size: small;
    text-transform: uppercase;
  }

  &__date {
    color: #fff;
    padding: 6px;
    border-radius: 4px;
    font-size: small;

    &--finish {
      background-color: var(--his-red);
    }

    &--start {
      background-color: var(--his-green);
    }
  }

  &__priority {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background-color: var(--his-steel-blue);
    border-radius: 50%;
    width: 32px;
    height: 32px;

    // To align with the "More options" button
    margin-right: var(--f7-button-padding-horizontal);
  }
}
</style>
